import {ComboboxItem} from '@/components/ui/combobox-atoms/ComboboxAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Users01Icon} from '@/components/ui/icon/Icon'
import {AgendaSidebarSearchList} from '@/features/agenda/components/agenda-sidebar-search/AgendaSidebarSearchList'
import {StyledComboboxItemTrimmedText} from '@/features/agenda/components/agenda-sidebar-search/style'
import {usePatients as useGetEquipe} from '@/features/patients/services/usePatients'
import {useTranslation} from '@/translations/i18n'

interface AgendaSidebarSearchEquipeListProps {
    search?: string
    isQueryEnabled: boolean
}

export const AgendaSidebarSearchEquipeList = ({search, isQueryEnabled}: AgendaSidebarSearchEquipeListProps) => {
    const {t} = useTranslation()
    const {
        data: team,
        isLoading,
        isError
    } = useGetEquipe(
        {
            search,
            page: 1,
            limit: 5
        },
        undefined,
        {
            enabled: isQueryEnabled
        }
    )

    return (
        <AgendaSidebarSearchList
            isLoading={isLoading}
            isError={isError}
            items={team?.data}
            icon={<Users01Icon size={15} />}
            labelText={
                <Flexbox fullWidth justify="space-between">
                    {t('agenda:patient_equipe')}
                </Flexbox>
            }
            renderItem={patient => (
                <ComboboxItem
                    hasItemCheckbox
                    key={patient.id}
                    value={patient.id}
                    data-value={patient.id}
                    data-source="team"
                    data-name={patient.fullName}
                >
                    <StyledComboboxItemTrimmedText>{patient.fullName}</StyledComboboxItemTrimmedText>
                </ComboboxItem>
            )}
        />
    )
}
